/*
 * MONOLITH — Bewegung fuer sections/rxk-mo-*.liquid.
 *
 * Jede Szene [data-mo-szene] bekommt --p (0…1): wie weit ihr klebender
 * Bildschirm durchgescrollt ist. CSS macht daraus die Bewegung.
 * Dazu: Zaehler [data-mo-zahl], Seitwaerts-Band der Steine, Bildwechsel im
 * Handwerk-Kapitel, Einblenden [data-mo-rein].
 * Keine Abhaengigkeiten. Bei prefers-reduced-motion nur Einblenden, keine Szenen.
 */
(() => {
  if (window.__rxkMonolith) return;
  window.__rxkMonolith = true;

  const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lang = document.documentElement.lang || 'de';
  const zahlFormat = (wert, stellen) =>
    new Intl.NumberFormat(lang, { minimumFractionDigits: stellen, maximumFractionDigits: stellen }).format(wert);

  const start = () => {
    document.documentElement.classList.add('mo-js');

    /* Einblenden */
    const rein = document.querySelectorAll('[data-mo-rein]');
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((eintraege) => {
        for (const e of eintraege) if (e.isIntersecting) { e.target.classList.add('ist-drin'); io.unobserve(e.target); }
      }, { rootMargin: '0px 0px -10% 0px' });
      rein.forEach((el) => io.observe(el));
    } else {
      rein.forEach((el) => el.classList.add('ist-drin'));
    }

    /* Handwerk: Bild passend zum sichtbaren Schritt */
    document.querySelectorAll('[data-mo-hand]').forEach((kapitel) => {
      const schritte = kapitel.querySelectorAll('[data-mo-schritt]');
      const bilder = kapitel.querySelectorAll('[data-mo-bild]');
      const setze = (i) => {
        schritte.forEach((s, j) => s.classList.toggle('ist-aktiv', j === i));
        bilder.forEach((b, j) => b.classList.toggle('ist-aktiv', j === i));
      };
      setze(0);
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((eintraege) => {
        for (const e of eintraege) if (e.isIntersecting) setze([...schritte].indexOf(e.target));
      }, { rootMargin: '-45% 0px -45% 0px' });
      schritte.forEach((s) => io.observe(s));
    });

    if (ruhig) return;

    const szenen = [...document.querySelectorAll('[data-mo-szene]')];
    if (!szenen.length) return;

    /* Seitwaerts-Band: Weg und Szenenhoehe aus der tatsaechlichen Bandbreite */
    const baender = szenen.filter((s) => s.hasAttribute('data-mo-band'));
    const vermesse = () => {
      for (const s of baender) {
        const band = s.querySelector('.mo-steine__band');
        if (!band) continue;
        if (window.innerWidth <= 900) { s.style.removeProperty('--mo-steine-hoehe'); continue; }
        const weg = Math.max(0, band.scrollWidth - window.innerWidth);
        s.style.setProperty('--mo-band-weg', weg + 'px');
        /* Wie lange gescrollt werden muss, richtet sich nach dem tatsaechlichen
           Weg des Bandes — ein fester Wert waere mal zu kurz (das Band kaeme nie
           durch), mal zu lang (Leerlauf am Ende). Das Tempo aus den Einstellungen
           streckt oder staucht nur diesen Weg. */
        const tempo = parseFloat(getComputedStyle(s).getPropertyValue('--mo-steine-tempo')) || 1;
        s.style.setProperty('--mo-steine-hoehe', (weg * tempo + window.innerHeight * 1.15) + 'px');

        /* Deckel fuer die Kartenbreite aus dem tatsaechlich freien Platz.
           Das Stylesheet schaetzt ihn aus festen Werten; wie hoch der Kopf
           wirklich ist, weiss aber nur der Browser — ein langer Titel bricht
           bei grosser Schrift um und braucht dann die doppelte Hoehe. Ohne
           diese Messung ragen die Bilder unten aus der Buehne und werden
           abgeschnitten. */
        const buehne = s.querySelector('.mo-szene__buehne');
        const kopf = s.querySelector('.mo-steine__kopf');
        const karte = s.querySelector('.mo-stein');
        const bild = karte && karte.querySelector('.mo-stein__bild');
        if (buehne && kopf && karte && bild && bild.offsetHeight > 0) {
          const seiten = bild.offsetWidth / bild.offsetHeight;
          const unterBild = karte.offsetHeight - bild.offsetHeight;
          const bandUnten = parseFloat(getComputedStyle(band).paddingBottom) || 0;
          const frei = buehne.clientHeight - kopf.offsetHeight - unterBild - bandUnten;
          s.style.setProperty('--mo-stein-deckel', Math.max(160, frei * seiten) + 'px');
        }
      }
    };

    /* Band: weich nachgefuehrt statt Schritt fuer Schritt.
       Mausraeder scrollen in Stufen von ~100px; setzt man die Verschiebung
       direkt, springt das Band mit jeder Stufe — das "Wackeln". Hier laeuft
       die Position zeitbasiert (unabhaengig von 60/120 Hz) dem Ziel hinterher
       und wird als px-Wert per translate3d gesetzt, ohne CSS-calc je Frame. */
    const WEICH_MS = 200;
    const bandLauf = new Map();
    let bandFrame = 0, bandZeit = 0;
    const bandSchritt = (jetzt) => {
      const dt = Math.min(64, jetzt - (bandZeit || jetzt));
      bandZeit = jetzt;
      const k = 1 - Math.exp(-dt / WEICH_MS);
      let weiter = false;
      for (const [s, z] of bandLauf) {
        z.x += (z.ziel - z.x) * k;
        if (Math.abs(z.ziel - z.x) < 0.3) z.x = z.ziel; else weiter = true;
        s.style.setProperty('--mo-band-x', z.x.toFixed(2) + 'px');
        s.classList.toggle('ist-in-fahrt', z.x !== z.ziel);
      }
      bandFrame = weiter ? requestAnimationFrame(bandSchritt) : 0;
      if (!weiter) bandZeit = 0;
    };
    const bandZiel = (s, p) => {
      const weg = parseFloat(s.style.getPropertyValue('--mo-band-weg')) || 0;
      const ziel = window.innerWidth <= 900 ? 0 : -p * weg;
      const z = bandLauf.get(s);
      if (!z) { bandLauf.set(s, { x: ziel, ziel }); s.style.setProperty('--mo-band-x', ziel.toFixed(2) + 'px'); return; }
      z.ziel = ziel;
      if (!bandFrame) bandFrame = requestAnimationFrame(bandSchritt);
    };

    let geplant = false;
    const rechne = () => {
      geplant = false;
      for (const s of szenen) {
        const r = s.getBoundingClientRect();
        // Buehne klebt unter dem Shop-Kopf: ihr top-Wert ist der Nullpunkt
        const buehne = s.querySelector('.mo-szene__buehne');
        const oben = buehne ? parseFloat(getComputedStyle(buehne).top) || 0 : 0;
        const lauf = Math.max(1, r.height - (buehne ? buehne.offsetHeight : window.innerHeight));
        const p = Math.min(1, Math.max(0, (oben - r.top) / lauf));
        s.style.setProperty('--p', p.toFixed(4));
        if (s.hasAttribute('data-mo-band')) bandZiel(s, p);
        s.querySelectorAll('[data-mo-zahl]').forEach((z) => {
          const von = parseFloat(z.dataset.von), bis = parseFloat(z.dataset.bis);
          const stellen = parseInt(z.dataset.stellen || '1', 10);
          // weich auslaufend: schnell am Anfang, langsam zum Ziel
          const k = 1 - Math.pow(1 - p, 3);
          const ziel = z.querySelector('[data-mo-zahl-wert]') || z;
          ziel.textContent = zahlFormat(von + (bis - von) * k, stellen);
        });
      }
    };
    const plane = () => { if (!geplant) { geplant = true; requestAnimationFrame(rechne); } };

    vermesse();
    rechne();
    // capture: Horizon scrollt ab 990px in .page-wrapper statt im Fenster,
    // dessen scroll-Ereignisse steigen nicht bis window auf
    window.addEventListener('scroll', plane, { passive: true, capture: true });
    window.addEventListener('resize', () => { vermesse(); plane(); });
    window.addEventListener('load', () => { vermesse(); plane(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
